import { fetchGet } from '../helperApi'

export const fetchAssessmentPackageDataApi = assessmentPackageId => {
    return fetchGet(`assessment/packages/${assessmentPackageId}`)
}
